const template = `
  <style>
    .price-progress__wrapper {
      display: grid;
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .price-progress__label {
      text-transform: var(--price-progress-label-transform, uppercase);
      font: var(--price-progress-label-font, bold 12px 'Montserrat', sans-serif);
      letter-spacing: var(--price-progress-label-letter-spacing, 0.16em);
      text-align: var(--price-progress-label-align, left);
      margin: 0;
      line-height: 16px;
    }

    .price-progress__progress {
      height: var(--price-progress-height, 4px);
      border-radius: 10px;
      background-color: var(--price-progress-bg-color, var(--color-pale-pink));
    }

    .price-progress__progress span {
      display: block;
      border-radius: inherit;
      height: var(--price-progress-height, 4px);
      background: var(--price-progress-bg, var(--color-black));
      width: var(--progress-width);
      transition: 0.3s ease width;
    }
  </style>
  <div class="price-progress__wrapper">
    <h2 class="price-progress__label"></h2>
    <span class="price-progress__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100">
      <span></span>
    </span>
  </div>
`
class PriceProgress extends HHBaseElement {
  constructor() {
    super(template)
    this.$label = this._shadowRoot.querySelector('.price-progress__label')
    this.$wrapper = this._shadowRoot.querySelector('.price-progress__progress')
  }

  get labelPattern() {
    return this.getAttribute('label')
  }

  get completionLabel() {
    return this.getAttribute('complete-label')
  }

  get label() {
    if (Shopify.currency.active == 'GBP') {
      return this.labelPattern.replace(
        /###/i,
        Shopify.formatMoney(this.balance, '£{{amount}}')
      )
    } else {
      return this.labelPattern.replace(
        /###/i,
        Shopify.formatMoney(this.balance)
      )
    }
  }

  get balance() {
    return Math.abs(this.limit - this.value)
  }

  get value() {
    return Number(this.getAttribute('value'))
  }

  set value(value) {
    return this.setAttribute('value', value)
  }

  get limit() {
    return Number(this.getAttribute('limit'))
  }

  set limit(limit) {
    return this.setAttribute('limit', limit)
  }

  get progress() {
    return this.value / this.limit
  }

  static get observedAttributes() {
    return ['value', 'limit', 'label', 'complete-label']
  }

  attributeChangedCallback() {
    this.applyState()
  }

  connectedCallback() {
    this.applyState()
  }

  applyState() {
    this.style.setProperty(
      '--progress-width',
      `${Math.min(this.progress, 1) * 100}%`
    )
    this.$wrapper.setAttribute(
      'aria-valuenow',
      Math.min(this.progress, 1) * 100
    )
    this.$wrapper.setAttribute('aria-busy', this.progress > 0)

    if (this.progress >= 1) {
      if (this.completionLabel) {
        this.$label.innerHTML = this.completionLabel
        this.style.display = ''
      } else {
        this.style.display = 'none'
      }
    } else {
      this.$label.innerHTML = this.label
      this.style.display = ''
    }
  }
}
window.customElements.define('price-progress', PriceProgress)
